import { AuthRoutes } from './type'

const root = `${AuthRoutes.root}`
const login = `${root}/${AuthRoutes.login}`
const forgot = `${root}/${AuthRoutes.forgot}`

export const AuthPath = {
  root: root,
  login: login,
  forgot: forgot,
}
